import { DispatcherEvent } from '@carvana/merch-native';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import { getUserAvailability, getVehicleDetailsForNative } from '~/selectors';
import useSelector from '~/store/useSelector';
import sendMessageToNative from './sendMessageToNative';

export default function useNativeMessageDispatcher() {
  const availability = useSelector(getUserAvailability);
  const payload = useSelector(getVehicleDetailsForNative);
  const { spinnerReady } = useContext(GlobalContext);

  useEffectOnce(
    () => {
      sendMessageToNative(DispatcherEvent.PageReady, {
        ...payload,
        navigationToNowMs: performance.now()
      });
    },
    [payload],
    availability.isLoaded && spinnerReady.isLoaded
  );
}
